<script setup lang="ts">
import { AppCoreEnums } from '../../shared/enums';
import { PropType, computed, ref, watchEffect } from 'vue';
import AppDynamicFilterItemBaseMenuValue from './app-dynamic-filter-item-base-menu-value.vue';
import AppDynamicFilterItemBaseMenuActions from './app-dynamic-filter-item-base-menu-actions.vue';
import useContainerDynamicFilters from '../../composable/containers/use-container-dynamic-filters';
import { IDateRange, IDynamicFilterItem, IDynamicFilterValueOptions } from '../../../stores/core/models';

const selectedFilterValue = defineModel<string | string[] | IDateRange | undefined>('selected');
const emit = defineEmits(['hide-menu']);

const props = defineProps({
  filterKey: {
    type: String,
    required: true,
  },
  options: {
    type: Array as PropType<IDynamicFilterValueOptions[]>,
    required: true,
  },
  containerType: {
    type: Number as PropType<AppCoreEnums.ContainerType>,
    required: true,
  },
});

const { addDynamicFilterItem, removeDynamicFilterItem, containerDynamicFilters } = useContainerDynamicFilters(
  props.containerType
);
const filterOptions = computed(() => props.options.find((x) => x.key === props.filterKey));

watchEffect(
  () =>
    (selectedFilterValue.value = containerDynamicFilters.value.find((x) => x.key == props.filterKey)?.value as
      | string
      | string[]
      | IDateRange
      | undefined)
);

const onApplyFilter = (filterItem: IDynamicFilterItem) => {
  addDynamicFilterItem(filterItem);
  emit('hide-menu');
};

const onRemove = (filterItem: IDynamicFilterItem) => {
  removeDynamicFilterItem(filterItem);
  emit('hide-menu');
};

const selectedFilterValueOptions = computed(() =>
  props.filterKey ? props.options.find((x) => x.key === props.filterKey) : undefined
);
</script>

<template>
  <div class="w-full pb-2 text-slate-500 dark:text-slate-400">{{ $t(filterOptions?.label || '') }}</div>
  <app-dynamic-filter-item-base-menu-value :filter-value-options="filterOptions" v-model:filter-value="selectedFilterValue" />

  <div class="mt-6">
    <app-dynamic-filter-item-base-menu-actions
      @add-filter="onApplyFilter"
      @cancel="$emit('hide-menu')"
      @remove-filter="onRemove"
      :enable-clear="!!selectedFilterValue"
      :filter-key="props.filterKey"
      :filter-value="selectedFilterValue"
      :filter-value-options="selectedFilterValueOptions"
    />
  </div>
</template>
